<script>
import { nextTick } from 'vue'

import MessageBox from './common/MessageBox.vue'

import apiSamples from '@/api/api-samples'
import apiFiles from '@/api/api-files';

export default {
    name: 'FileImportComponent',

    components: {
        MessageBox
    },

    props: {
        languageStrings: {
            type: Object,
            default: null
        }
    },

    emits: ['form-closed'],

    computed: {
        fileNames() {
            let names = ''
            this.files.forEach((file) => {
                if (names.length > 0) {
                    names = names + ', '
                }
                names = names + file.name
            })
            return names
        }
    },

    data() {
        return {
            files: [],
            showMessage: false,
            message: '',
            messageType: -1,
            showMessageButtons: true
        }
    },

    async mounted() {
        await nextTick()
        document.getElementById('form').focus()
    },

    methods: {
        handleFormKeyDown(event) {
            if (event.key === 'Escape') {
                this.closeForm()
            }
        },
        closeForm() {
            this.$emit('form-closed')
        },
        openFileDialog() {
            this.$refs.fileInput.click()
        },
        async onFileInputChange() {
            this.files = []
            this.files.push(...this.$refs.fileInput.files)
            await this.uploadFiles()
        },
        async uploadFiles() {
            this.message = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.fileimport005 != null ? this.languageStrings.ui.fileimport005 : 'Nahrávám soubory...'
            this.messageType = 0
            this.showMessageButtons = false
            this.showMessage = true

            const files = this.files

            for (let i = 0; i < files.length; i++) {
                if (files[i].name.toLowerCase().endsWith('xml')) {
                    const text = await files[i].text()
                    let res = await apiFiles.uploadXmlFile(files[i].name.slice(0, -4), text)
                    if (res.code === 1) {
                        this.message = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.fileimport007 != null ? this.languageStrings.ui.fileimport007 : 'Chyba nahrávání souborů'
                        this.messageType = 1
                        this.showMessageButtons = true
                        return
                    }
                    continue
                }

                const parts = files[i].name.split('.')[0].split('_').filter(x => x)
                let result = await apiSamples.sif(parts[0])
                if (result.code == 0) {
                    const fid = result.data.machine.folder.id
                    const mid = result.data.machine.id
                    const sid = result.data.id

                    result = await apiSamples.getSamplesAttachments(sid)
                    if (result.code == 0) {
                        const formData = new FormData()
                        formData.append("selectedFiles", files[i])

                        if (result.data.length > 0 && result.data.find(x => x.name.toLowerCase() === files[i].name.toLowerCase()) != null) {
                            // att exists
                            result = await apiFiles.uploadFile(fid, result.data.find(x => x.name.toLowerCase() === files[i].name.toLowerCase()).id, formData, parts[0])
                            if (result.code === 1) {
                                this.message = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.fileimport007 != null ? this.languageStrings.ui.fileimport007 : 'Chyba nahrávání souborů'
                                this.messageType = 1
                                this.showMessageButtons = true
                                return
                            }
                        }
                        else {
                            // att not exists
                            result = await apiSamples.postSampleAttachment(sid, { id: 0, name: files[i].name, size: files[i].size, sample: { id: sid, alsNumber: parts[0], machine: { id: mid, folder: { id: fid } } } })
                            if (result.code === 0) {
                                result = await apiFiles.uploadFile(fid, result.data.id, formData, parts[0])
                                if (result.code === 1) {
                                    this.message = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.fileimport007 != null ? this.languageStrings.ui.fileimport007 : 'Chyba nahrávání souborů'
                                    this.messageType = 1
                                    this.showMessageButtons = true
                                    return
                                }
                            }
                            else {
                                this.message = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.fileimport007 != null ? this.languageStrings.ui.fileimport007 : 'Chyba nahrávání souborů'
                                this.messageType = 1
                                this.showMessageButtons = true
                                return
                            }
                        }
                    }
                }
            }
            
            this.message = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.fileimport006 != null ? this.languageStrings.ui.fileimport006 : 'Soubory nahrány'
            this.showMessageButtons = true
        },
        async messageBoxClosed(type) {
            this.files = []
            this.$refs.fileInput.value = null

            switch (type) {
                case 1:
                    this.showMessage = false
                    this.closeForm()
                    return
                default:
                    this.showMessage = false
                    break
            }
            await nextTick()
            document.getElementById('form').focus()
        }
    }
}
</script>

<template>
    <div class="form">
        <div id="form" @keydown="handleFormKeyDown" tabindex="-1">
            <span class="title">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu014 != null ? languageStrings.ui.menu014 : 'Import souborů' }}</span>
            <img src="@/assets/images/x.svg" @click="closeForm()" />

            <div class="form-wrapper">
                <div class="form-content rows gap-10">
                    <div class="file-input">
                        <input type="file" multiple name="fileInput" id="fileInput" @change="onFileInputChange" ref="fileInput" accept="*" />
                        <input type="text" v-bind:value="fileNames" readonly />
                        <button class="button-small" @click="openFileDialog">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport001 != null ? languageStrings.ui.fileimport001 : 'Zvolit soubory' }}</button>
                    </div>
                    <div style="font-size: 9pt;">
                        {{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport002 != null ? languageStrings.ui.fileimport002 : 'Název souboru musí začínat SIF číslem nebo podtržítkem a SIF číslem.' }}
                        <br />
                        {{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport003 != null ? languageStrings.ui.fileimport003 : 'Např.' }}:
                        <b>123456_foto.jpg</b> 
                        {{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport004 != null ? languageStrings.ui.fileimport004 : 'nebo' }} 
                        <b>_123456_foto.jpg</b>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <MessageBox v-if="showMessage" :text="message" @form-closed="messageBoxClosed" :type="messageType" :showButtons="showMessageButtons" />
</template>